var LinkType;
(function (LinkType) {
    LinkType["LINK"] = "link";
    LinkType["LARGE_LINK"] = "large-link";
    LinkType["BUTTON_STANDARD_POSITIVE"] = "button--positive";
    LinkType["BUTTON_STANDARD_NEGATIVE"] = "button--negative";
    LinkType["BUTTON_LARGE_POSITIVE"] = "button--large-positive";
    LinkType["BUTTON_LARGE_NEGATIVE"] = "button--large-negative";
    LinkType["BUTTON_SMALL_POSITIVE"] = "button--small-positive";
    LinkType["BUTTON_SMALL_NEGATIVE"] = "button--small-negative";
    LinkType["INLINE"] = "inline";
    LinkType["RETURN"] = "return";
    LinkType["ICON"] = "sgw-button button--icon";
})(LinkType || (LinkType = {}));
export default LinkType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGlua1R5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9AZWlrYS9saW5rL3NyYy9MaW5rVHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFLLFFBWUo7QUFaRCxXQUFLLFFBQVE7SUFDVCx5QkFBYSxDQUFBO0lBQ2IscUNBQXlCLENBQUE7SUFDekIseURBQTZDLENBQUE7SUFDN0MseURBQTZDLENBQUE7SUFDN0MsNERBQWdELENBQUE7SUFDaEQsNERBQWdELENBQUE7SUFDaEQsNERBQWdELENBQUE7SUFDaEQsNERBQWdELENBQUE7SUFDaEQsNkJBQWlCLENBQUE7SUFDakIsNkJBQWlCLENBQUE7SUFDakIsNENBQWdDLENBQUE7QUFDcEMsQ0FBQyxFQVpJLFFBQVEsS0FBUixRQUFRLFFBWVo7QUFNRCxlQUFlLFFBQVEsQ0FBQyJ9